document.addEventListener('DOMContentLoaded', function() {
  var cityList = document.querySelector('.city-list');
  var storeList = document.querySelector('.store-list');
  var stateList = document.querySelector('.state-list');
  var cityButton = document.getElementById('cityButton');
  var stateButton = document.getElementById('stateButton');
  var searchInput = document.querySelector('.inputArea'); // Search bar

  // Helpers
  var norm = function(v){ return (v || '').toString().trim().toLowerCase(); };

  // Store data (minimal example you pasted)
  var storeData = {
    "stores": [
      { "state": "Maharashtra", "city": "Mumbai", "name": "Inorbit Mall, Malad, Mumbai", "pincode": "400064" },
      { "state": "Maharashtra", "city": "Mumbai", "name": "Phoenix Marketcity, Kurla, Mumbai", "pincode": "400070" },
      { "state": "Maharashtra", "city": "Mumbai", "name": "Infiniti Mall, Malad, Mumbai", "pincode": "400064" },
      { "state": "Maharashtra", "city": "Mumbai", "name": "Oberoi Mall, Goregaon, Mumbai", "pincode": "400063" },
      { "state": "Maharashtra", "city": "Navi Mumbai", "name": "Inorbit Mall, Vashi, Navi Mumbai", "pincode": "400705" }
      // Add remaining store data here...
    ]
  };

  // Create a lookup map: storeName(lower) => pincode
  var pincodeMap = {};
  if (storeData && storeData.stores && storeData.stores.length) {
    storeData.stores.forEach(function(s) {
      pincodeMap[norm(s.name)] = (s.pincode || '').toString().trim();
    });
  }

  // Default: Show cities by default
  cityButton.style.backgroundColor = '#C24175';
  cityButton.style.color = 'white';
  cityButton.style.transform = 'scale(1)';
  stateButton.style.backgroundColor = '';
  stateButton.style.color = '';
  stateButton.style.transform = 'scale(0.9)';
  cityList.style.display = 'grid';
  stateList.style.display = 'none';
  storeList.style.display = 'none';

  // Toggle between Cities and States
  cityButton.addEventListener('click', function() {
    cityButton.style.backgroundColor = '#C24175';
    cityButton.style.color = 'white';
    cityButton.style.transform = 'scale(1)';
    stateButton.style.backgroundColor = '';
    stateButton.style.color = '';
    stateButton.style.transform = 'scale(0.9)';

    cityList.style.display = 'grid';
    stateList.style.display = 'none';
    storeList.style.display = 'none';
  });

  stateButton.addEventListener('click', function() {
    stateButton.style.backgroundColor = '#C24175';
    stateButton.style.color = 'white';
    stateButton.style.transform = 'scale(1)';
    cityButton.style.backgroundColor = '';
    cityButton.style.color = '';
    cityButton.style.transform = 'scale(0.9)';

    stateList.style.display = 'flex';
    cityList.style.display = 'none';
    storeList.style.display = 'none';
  });

  // ✅ FIXED: When clicking a state, show only stores in that state
  document.querySelectorAll('.state-address').forEach(function(stateEl) {
    stateEl.addEventListener('click', function() {
      var selectedState = norm(this.getAttribute('data-state'));

      document.querySelectorAll('.store-address').forEach(function(store) {
        var storeState = norm(store.getAttribute('data-state'));
        store.style.display = (storeState === selectedState) ? 'flex' : 'none';
      });

      stateList.style.display = 'none';
      storeList.style.display = 'flex';
      cityList.style.display = 'none';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // City wise filtering (kept same, but normalized)
  document.querySelectorAll('.city-address').forEach(function(city) {
    city.addEventListener('click', function() {
      var selectedCity = norm(this.getAttribute('data-city'));

      document.querySelectorAll('.store-address').forEach(function(store) {
        var storeCity = norm(store.getAttribute('data-city'));
        store.style.display = (storeCity === selectedCity) ? 'flex' : 'none';
      });

      cityList.style.display = 'none';
      storeList.style.display = 'flex';
      stateList.style.display = 'none';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // SEARCH FUNCTIONALITY
  searchInput.addEventListener('input', function() {
    var searchValue = norm(this.value);
    var isNumber = /^\d+$/.test(searchValue); // pincode check

    var activeSection =
      (cityList.style.display === 'grid') ? 'city' :
      (stateList.style.display === 'flex') ? 'state' : 'store';

    if (!searchValue) {
      // If empty input, do nothing special (keep current view)
      return;
    }

    if (isNumber) {
      // ✅ Pincode Search (works with data-pincode OR fallback map by store name)
      document.querySelectorAll('.store-address').forEach(function(store) {
        var cardPincode = (store.getAttribute('data-pincode') || '').toString().trim();
        if (!cardPincode) {
          var storeName = norm(store.getAttribute('data-store-name') || store.querySelector('h3')?.textContent || '');
          cardPincode = pincodeMap[storeName] || '';
        }
        store.style.display = cardPincode.includes(searchValue) ? 'flex' : 'none';
      });

      storeList.style.display = 'flex';
      cityList.style.display = 'none';
      stateList.style.display = 'none';
    } else {
      // Text Search
      if (activeSection === 'city') {
        document.querySelectorAll('.city-address').forEach(function(city) {
          city.style.display = norm(city.textContent).includes(searchValue) ? 'flex' : 'none';
        });
      } else if (activeSection === 'state') {
        document.querySelectorAll('.state-address').forEach(function(state) {
          // ✅ FIX: was 'flow' -> should be 'flex'
          state.style.display = norm(state.textContent).includes(searchValue) ? 'flex' : 'none';
        });
      } else {
        document.querySelectorAll('.store-address').forEach(function(store) {
          store.style.display = norm(store.textContent).includes(searchValue) ? 'flex' : 'none';
        });
      }
    }
  });
});

// Share Function
function share(e, t) {
  window.open("https://api.whatsapp.com/send?text=" + e + " | " + t, "_blank");
}
